export const localStorage = {
  CONNECTION: 'sso.saml_connection',
};

export const employerSignInHelpLink =
  'https://help.seek.com.au/employer/s/article/I-ve-tried-to-sign-in-why-haven-t-I-received-an-email#:~:text=SEEK%20emails%20and%20links%20can,email%20away%20from%20your%20Inbox';

export const localhostApi = 'http://localhost:3002';
